import { render, staticRenderFns } from "./ListNews.vue?vue&type=template&id=4ad0a704"
import script from "./ListNews.vue?vue&type=script&lang=js"
export * from "./ListNews.vue?vue&type=script&lang=js"
import style0 from "./ListNews.vue?vue&type=style&index=0&id=4ad0a704&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports